module.exports = __webpack_public_path__ + "fonts/icons.25a6bb0.woff";